import { bulkResizeSelector } from "store/features/bulkResize/selectors/bulkResizeSelector";
import { BulkResizeState } from "store/features/bulkResize/types";
import { setPercentage } from "store/features/bulkResize/actions";
import { useAppSelector, useAppDispatch } from "store/store";

export const usePercentage = () => {
    const {
        resizeSettings: {
            byPercentage: { percentage },
        },
    } = useAppSelector(bulkResizeSelector, equalityFn);
    const dispatch = useAppDispatch();

    const handleChange = (value: number) => dispatch(setPercentage(value));

    return {
        percentage,
        handleChange,
    };
};

const equalityFn = (
    left: BulkResizeState,
    right: BulkResizeState
) => {
    if (
        left.resizeSettings.byPercentage.percentage !==
        right.resizeSettings.byPercentage.percentage
    )
        return false;

    return true;
};
